module.exports = {
  appVersion: '1.70',
  aliasHeader: 'X-MT-Company',
  email: { href: 'mailto:support@moo.team', text: 'support@moo.team' },
  telegram: { href: 'https://t.me/mooteamchat', text: '@mooteamchat' },
  telegramUpdates: { href: 'https://t.me/mooteam', text: '@mooteam' },
  backendUrl: process.env.REACT_APP_BACKEND_URL,
  websocketUrl: process.env.REACT_APP_WEBSOCKET_URL,
  newAppUrl: process.env.REACT_APP_NEW_APP_URL,
  yandexClientId: '89196cd8bba042219ed7ca17754d4b20',
  googleApi: {
    url: 'https://accounts.google.com/o/oauth2/v2/auth',
    clientId: process.env.REACT_APP_DRIVE_CLIENT_ID,
    search: {
      scope: 'https://www.googleapis.com/auth/webmasters.readonly',
      redirectUrl: '/projects/project-google-token',
    },
    drive: {
      scope: 'https://www.googleapis.com/auth/drive',
      redirectUrl: '/company-drive-token',
    },
  },
  appTitle: 'Moo.Team',
  footerText: 'Powered by Webest.pro © 2021',
  numberFormat: 'ru-RU',
  locale: {
    languageId: 'russian',
    locale: 'ru',
    name: 'Русский',
    icon: 'ru',
  },
  ckEditor: {
    allowedContent: true,
    extraAllowedContent: 'iframe[*]',
  },
  dadata: {
    url: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/party',
    token: 'aec445f125c9a3b01bfd808896025166dee9044c',
  },
  defaultTimezone: 'Europe/Moscow',
  backendDateFormat: 'YYYY-MM-DD',
  backendDateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
  dateFormat: 'DD.MM.YYYY',
  timeFormat: 'HH:mm',
  dateTimeFormat: 'DD.MM.YYYY HH:mm:ss',
  // Universal layout of form items for antd forms
  formItemLayout: {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 4 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
  },
  // Antd default form width
  defaultFormWidth: '70%',
  storage: {
    entitiesUpdatedCheckIntervalMs: getEnvIntOrDefault(
      'REACT_APP_STORAGE_ENTITIES_UPDATED_CHECK_INTERVAL_MS',
      60 * 5 * 1000,
    ), // default 5min, 0 - disabled
  },
};

/**
 * Get env variable or use default value
 *
 * @param {string} name
 * @param {number} default
 * @returns {number}
 */
function getEnvIntOrDefault(varName, defaultVal) {
  if (typeof process.env[varName] === 'undefined' || !process.env[varName]) {
    return defaultVal;
  }

  const value = parseInt(process.env[varName]);
  if (isNaN(value)) {
    return defaultVal;
  }

  return value;
}
